import detectMobileStatus from '../partials/mobile-detect'

const filterSelect = () => {
  $('.custom-select select').mousedown(function (e) {
    if (detectMobileStatus() == false) {
      e.preventDefault()
      var target = $(this).parent()
      $('.custom-select').not(target).removeClass('is-active')
      $(this).parent().toggleClass('is-active')
    }
  })

  $(document).click(function (event) {
    $target = $(event.target)

    if (
      !$target.closest('.custom-select').length &&
      $('.custom-select ul').is(':visible')
    ) {
      $('.custom-select').removeClass('is-active')
    }
  })

  $('.custom-select ul li').click(function () {
    var customSelect = $(this).closest('.custom-select')
    var value = $(this).data('value')
    customSelect.find('li').removeClass('selected')
    $(this).addClass('selected')
    customSelect.removeClass('is-active')
    customSelect.find('select').val(value)
    customSelect.find('select').trigger('change')
  })
}

export default filterSelect
